import GlobalDispatchMethods from "../../context/globalDispatchMethods";

function addNotification(dispatch, message, success) {
  if (!dispatch) {
    return;
  }

  dispatch({
    type: GlobalDispatchMethods.AddNotification,
    notification: {
      message,
      success,
    },
    dispatch,
  });
}

function addSuccessNotification(dispatch, message) {
  addNotification(dispatch, message, true);
}

function addFailureNotification(dispatch, message) {
  addNotification(dispatch, message, false);
}

function getServiceErrorMessage(error) {
  if (!error) {
    return "An unexpected error occurred";
  }

  if (error.response && error.response.data) {
    const data = error.response.data;

    if (typeof data === "string") {
      return data;
    }

    return data.Message || data.message || "An unexpected error occurred";
  }

  return error.message;
}

export {
  addFailureNotification,
  addNotification,
  addSuccessNotification,
  getServiceErrorMessage,
};
